import React from 'react';
import AboutMainWrap from "../style/wrap";
import Container from "../../../../components/paper/container";
import SectionTitle from "../../../../components/heading/section";
import {Button, Card, Col, Row, Space} from "antd";
import CardTitle from "../../../../components/heading/card";
import P1 from "../../../../components/paragraph";
import ChartImage1 from '../../../../assets/img/landlord1.png'
import ChartImage2 from '../../../../assets/img/landlord2.png'
import ChartImage3 from '../../../../assets/img/landlord3.png'
import styled from "styled-components"
import {Icon} from '@iconify/react';
import AuthLayout from '../../../../layouts/auth.layout';

const AboutMain = () => {
    return (
        <AboutMainWrap>
            <Container>
                <Space direction='vertical' size={32} style={{width: '100%', paddingTop: '10px'}}>
                    <Row gutter={[32, 32]}>
                        <Col lg={{span: 8}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <div style={{
                                        position: 'relative',
                                        paddingTop: '0%',
                                    }}>
                                    <img src={ChartImage1} alt="" style={{paddingBottom: '30px'}}/>
                                    <P1>
                                    <div>
                                        <ul><li><p><strong>Dashboard</strong><br/>Overview of all activities</p></li><li><p><strong>Service Requests</strong><br/>New maintenance and services requests</p></li><li><p><strong>Task Prioritization</strong><br/>Manage urgent and time sensitive tasks</p></li><li><p><strong>Messaging System</strong><br/>Messaging and communication with tenants</p></li></ul>
                                    </div>
                                    </P1>
                                </div>
                            </Space>
                        </Col>
                        <Col lg={{span: 8}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <div style={{
                                        position: 'relative',
                                        paddingTop: '0%',
                                    }}>
                                    <img src={ChartImage2} alt="" style={{paddingBottom: '30px'}}/>
                                    <P1>
                                    <div>
                                        <ul><li><p><strong>Online Rental Applications</strong><br/>New tenant rental applications</p></li><li><p><strong>Automatically Screen Tenants With AI</strong><br/>Screen new tenants quickly</p></li><li><p><strong>Unit Details</strong><br/>Unit details such as tenant, rent, lease, communication, maintenance and repair history</p></li><li><p><strong>Accounting System</strong><br/>Accounting ledger for property operations</p></li></ul>
                                    </div>
                                    </P1>
                                </div>
                            </Space>
                        </Col>
                        <Col lg={{span: 8}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <div style={{
                                        position: 'relative',
                                        paddingTop: '0%',
                                    }}>
                                    <img src={ChartImage3} alt="" style={{paddingBottom: '30px'}}/>
                                    <P1>
                                    <div>
                                        <ul><li><p><strong>Apartment Listing & Marketing</strong><br/>List and market units with MOGUL comparable pricing intelligence</p></li><li><p><strong>Customer CRM</strong><br/>Customer communications and marketing system</p></li><li><p><strong>Service Provider Network</strong><br/>Including plumbers, electrcians, repair and handymen</p></li></ul>
                                    </div>
                                    </P1>
                                </div>
                            </Space>
                        </Col>
                    </Row>
                </Space>
            </Container>
        </AboutMainWrap>
    );
};

const ActionFormCard = styled(Card)`
  box-shadow: none;
  border: none;
  background: linear-gradient(to top, #f4e1ff, #f4e1ff);
  border-radius: 12px;
  padding: 0px;

  h2 {
    text-align: center;
    //font-size: 28px;
    margin-bottom: 0px;
  }

  h3 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 0px;
  }

  @media (max-width: 768px) {
    padding: 0;
  }
`

export default AboutMain;
